module.exports = __webpack_public_path__ + "img/SKMJ_paper.61918031.png";